import { useQuery } from "@tanstack/react-query";
import { fetchAreaHierarchy } from "src/Pages/Company/OrganizationStructure/api";

const useFetchAreaHierarchy = (
  companyId: string,
  structureId: string | undefined,
  areaId: string
) =>
  useQuery({
    enabled: !!companyId && !!structureId && !!areaId,
    queryKey: ["hierarchy", companyId, structureId, areaId],
    queryFn: async ({ signal }) => {
      const data = await fetchAreaHierarchy(companyId, structureId!, areaId, {
        signal,
      });
      return data;
    },
  });

export default useFetchAreaHierarchy;
